import { render, staticRenderFns } from "./SiguenosEn.vue?vue&type=template&id=7128fc0e&scoped=true&functional=true&"
var script = {}
import style0 from "./SiguenosEn.vue?vue&type=style&index=0&id=7128fc0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7128fc0e",
  null
  
)

export default component.exports